import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { TAnalyticsEventSender, IDeps } from './models';
import { AnalyticsEventSender as Component } from './analytics-event-sender';

export const AnalyticsEventSender = createWidget<IDeps, TAnalyticsEventSender>({})(Component);
